import { Button as CloseButton, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { CloseSection } from "../../components/Popup/Popup.styles";
import { LoginModal as Modal } from "../../components/Popup/LoginModal";
import { Spacer } from "views/components/common/Spacer";
import { WizardSignUp } from "../../components/WizardSignUp";
import { RequestPassModal } from "views/mobile/components/Popup/RequestPassModal";
import {
	AlreadyRegisteredContainer,
	FooterModalWrapper,
	RegistryWrapper,
	TextCol,
	Wrapper,
} from "./styles";

import validate from "views/components/common/Input/inputValidation";

import { useSignup } from "../../../../hooks/useSignUp";
import React, { useEffect, useState } from "reactn";

const { Text } = Typography;

export const SignUpModal = ({
	handleMeet,
	setIsVisibleConfirmationModal,
	getReservation,
	blockreservation,
	visible,
	onClose,
	ticketAction,
	isActive,
	openWithoutLoginModal,
	handleOpenUpdateRutModal,
	openRutUpdateModal,
}) => {
	const [step, setStep] = useState(0);
	const [inputs, setInputs] = React.useState({});
	const [errors, setErrors] = React.useState({});
	const [info, setInfo] = React.useState({});
	const [corp, setCorp] = React.useState(false);

	const onChangeInputs = ({ input, value, type, required }) => {
		let results = validate(value, required, type);
		setErrors(results.errors);
		setInfo(results.information);
		setInputs((i) => ({ ...i, [input]: value }));
		if (results.information.corpEmail) {
			setCorp(true);
		}
	};

	const [submit, success, loading, error, setShowModal, showModal, user] =
		useSignup(
			onClose,
			getReservation,
			blockreservation,
			handleOpenUpdateRutModal,
			openRutUpdateModal,
			handleMeet
		);
	// const [submit, success, loading, error] = useSignUpV2(
	// 	onClose,
	// 	getReservation,
	// 	blockreservation
	// );

	useEffect(() => {
		if (step === 0) setCorp(false);
	}, [step]);

	useEffect(() => {
		if (success) {
			setIsVisibleConfirmationModal(true);
			setTimeout(() => {
				setIsVisibleConfirmationModal(false);
				ticketAction();
			}, 2000);
		}
	}, [success]);

	useEffect(() => {
		return () => setStep(0);
	}, []);
	const handlerAlreadyRegistered = () => {
		isActive();
		onClose();
	};
	useEffect(() => {
		setStep(0);
	}, [visible]);
	return (
		<>
			{showModal && (
				<RequestPassModal
					onCloseModal={onClose}
					getReservation={getReservation}
					blockreservation={blockreservation}
					user={user}
					setShowModal={setShowModal}
					visible={showModal}
					ticketAction={ticketAction}
					goToLogin={handlerAlreadyRegistered}
				/>
			)}
			<Modal visible={visible} destroyOnClose={true} onCancel={onClose}>
				{/* <CloseSection>
					<div onClick={onClose}>
						<CloseOutlined style={{ fontSize: 16 }} />
					</div>
				</CloseSection> */}
				<Wrapper>
					<TextCol>
						<Text className="title__login-modal">
							Crea tu cuenta
						</Text>
						<Text className="title__login-modal">
							¡en solo 2 pasos!
						</Text>
						<Spacer rows={1} />
						<Text className="modal__text-welcome" type="secondary">
							Regístrate y accede a tus sucursales favoritas,
							historial de tickets y más!
						</Text>
					</TextCol>
					{error && <div>{error.message}</div>}
				</Wrapper>
				<WizardSignUp
					step={step}
					setStep={setStep}
					loading={loading}
					inputs={inputs}
					onChangeInputs={onChangeInputs}
					errors={errors}
					info={info}
					corp={corp}
					onClick={submit}
				/>

				<Spacer rows={3} />

				<FooterModalWrapper>
					{step === 0 && visible && (
						<AlreadyRegisteredContainer>
							<span>
								<RegistryWrapper
									onClick={handlerAlreadyRegistered}
									className="signup__already-registered-anchor"
								>
									Ya tengo una cuenta
								</RegistryWrapper>
							</span>
						</AlreadyRegisteredContainer>
					)}
					<Spacer rows={2} />
					{/* <p>Recuerda que también puedes</p>
				<a
					className="noregistry__ticket-label"
					onClick={openWithoutLoginModal}
				>
					Continuar sin registrarte
				</a> */}
				</FooterModalWrapper>
			</Modal>
		</>
	);
};
